var Cube = require('cube-js')

require('../vendor/video.js')

var ReverseAction = require('../reverse-action');

var player = function player(conf) {
  this.container = conf.container;
  this.init();
};

Cube.mix(player.prototype, {

  container: null,
  player_list: {},
  is_phone: false,
  reverse_action: null,
  nav_header: null,

  init: function() {

    this.nav_header = $('#header .navbar');
    var me = this;

    this.is_phone = $(window).width() < 768;

    this.adjustSize();

    if (this.is_phone) {
      return;
    }

    var events = {
      'mouseenter li': 'mouseenter',
      'mouseleave li': 'mouseleave',
      'mousemove li': 'onMouseMove',
    };

    Cube.bindEvents(this, events, this.container);
    var reverse_action = new ReverseAction();
    this.reverse_action = reverse_action;

    reverse_action.on('show', function() {
      // me.nav_header.animate({'top': 0});
      console.log('start show');
    }, function() {
      // me.nav_header.stop();
      console.log('stop show');
    });
    reverse_action.on('hide', function() {
      console.log('start hide');
      // me.nav_header.animate({'top': -80});
    }, function() {
      // me.nav_header.stop();
      console.log('stop hide');
    });
  },

  onScroll: function(top) {
    if (!this.is_phone && top > 200) {
      this.reverse_action.do('show');
    }
  },

  onMouseMove: function(e) {
    var li = $(e.target).parents('li');
    var y = e.pageY;
    var index = li.data('index');
    if (index <= 3 && y >= 90) {
      this.reverse_action.do('hide');
    } else {
      this.reverse_action.do('show');
    }
  },

  createVideo: function(index) {
    var on_playing = Cube.bind(this.onPlaying, this);

    var that = this;
    var options = {};

    var id = 'video-' + index;
    var element = $('#' + id);
    var src = element.data('src');
    var index = element.parents('li').data('index');

    var player = videojs(id, options, function() {
      that.player_list[index] = this;
      this.on('playing', on_playing);
    });

    var src_data =  {
      type: "video/mp4",
      src: src
    };
    player.src(src_data);
  },

  onResize: function() {
    if (this.is_phone) {
      return;
    }
    this.adjustSize();
  },

  adjustSize: function() {
    var window_width = $(window).width();
    var size = window_width;
    if (window_width >= 768) {
      size = size / 3;
    }
    var css = {
      width: size,
      height: size,
    };
    this.container.find('.timelapse-item video').css(css);
    this.container.find('li').css(css);
    this.container.find('li .placeholder').css(css);
  },


  onPlaying: function(e) {
    var index = $(e.target).parents('li').data('index');
    this.removeVideoMask(index);
  },

  removeVideoMask: function(index) {
    var item = this.container.find('#video-' + index).parents('li');
    item.find('.timeline-video').css('opacity', 1);
    item.find('.placeholder').css('opacity', 0);
    item.find('.placeholder .text-box').css('opacity', 0);

    if (index <= 3) {
      // this.reverse_action.do('hide');
    }
  },

  mouseenter: function(e) {
    var item = $(e.target).parents('li');
    var index = item.data('index');

    if (!this.player_list[index]) {
      this.createVideo(index);
    }

    this.player_list[index].play();

    item.find('.placeholder').css('opacity', 0.8);
    item.find('.placeholder .text-box').css('opacity', 0);
  },

  mouseleave: function(e) {
    var item = $(e.target).parents('li');
    var index = item.data('index');
    Cube.forEach(this.player_list, function(player, index) {
      player.pause();
    });
    item.find('.timeline-video').css('opacity', 0);
    item.find('.placeholder').css('opacity', 1);
    item.find('.placeholder .text-box').css('opacity', 1);
    // this.reverse_action.do('show');
  },
});

module.exports = player;



//////////////////
// WEBPACK FOOTER
// ./src/js/home/videoplayer.js
// module id = 49
// module chunks = 3